import $ from 'jquery';
import footer from 'components/footer';
import saatchi from 'lib/tda/saatchi';
import tabControl from 'lib/util/tabControl';

$(function () {
  tabControl.init();
  saatchi.specialHandling();
});

export default footer;

